module.exports = __webpack_public_path__ + "img/gabriela.8f8f542d.webp";